<template>
  <section class="product-grid">
    <ProductGroupWrapper
      v-for="groupKey in sortedProductGroups"
      :key="groupKey"
      :products="getFilteredProducts[groupKey]"
    />
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ProductGroupWrapper from "./ProductGroupWrapper";

export default {
  name: "ProductGrid",
  components: {
    ProductGroupWrapper,
  },
  computed: {
    ...mapGetters(["getFilteredProducts"]),
    ...mapState(["categories"]),
    sortedProductGroups() {
      console.log("ProductGrid categories", this.categories);
      const sorted = Object.keys(this.getFilteredProducts).sort((a, b) => {
        console.log("ProductGrid sort", a, b);
        if (
          Object.keys(this.categories).includes(a) &&
          Object.keys(this.categories).includes(b)
        ) {
          return this.categories[a].term_order - this.categories[b].term_order;
        }
        return 1;
      });
      console.log("ProductGrid sorted", sorted);
      return sorted;
    },
  },
};
</script>

<style scoped></style>
